import chefPortrait1 from "../assets/chef-portrait-01.png";
import chefPortrait2 from "../assets/chef-portrait-02.png";

const HomeChefQuantifiableSuccess = () => (
  <section className="hc-section">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-5">
          <h2 className="hc-section-title text-start">
            Average
            <br />
            Partner Growth
          </h2>
          <p className="hc-muted">
            Our platform has helped over 5,000 chefs grow their business by an
            average of 214% in their first year.
          </p>
          <div className="hc-stat-chart">
            <div className="hc-bar" style={{ height: "30%" }} />
            <div className="hc-bar" style={{ height: "27%" }} />
            <div className="hc-bar" style={{ height: "40%" }} />
            <div className="hc-bar" style={{ height: "45%" }} />
            <div className="hc-bar" style={{ height: "55%" }} />
            <div className="hc-bar" style={{ height: "70%" }} />
            <div className="hc-bar" style={{ height: "65%" }} />
            <div className="hc-bar" style={{ height: "73%" }} />
            <div className="hc-bar" style={{ height: "77%" }} />
            <div className="hc-bar" style={{ height: "80%" }} />
            <div className="hc-bar" style={{ height: "85%" }} />
            <div className="hc-bar hc-bar-dark" style={{ height: "96%" }} />
          </div>
          <p className="hc-muted mt-2 mb-0">
            Average business growth in the first year
          </p>
          <p className="hc-stat-label">+214%</p>
        </div>
        <div className="col-lg-6 offset-lg-1">
          <div className="hc-testimonial-card">
            <div className="hc-testimonial-head">
              <img
                src={chefPortrait1}
                alt="Maria Rose"
                className="hc-avatar"
                width={48}
                height={48}
              />
              <div>
                <strong>Maria Rose</strong>
                <span className="hc-muted d-block">Executive Chef</span>
              </div>
            </div>
            <p>
              "Go Taste UK didn't just give me an app; they gave me a business.
              I tripled my orders without hiring a single driver."
            </p>
          </div>
          <div className="hc-testimonial-card mt-3">
            <div className="hc-testimonial-head">
              <img
                src={chefPortrait2}
                alt="Marcus Yates"
                className="hc-avatar"
                width={48}
                height={48}
              />
              <div>
                <strong>Marcus Yates</strong>
                <span className="hc-muted d-block">Home Chef Entrepreneur</span>
              </div>
            </div>
            <p>
              "Finally, a platform that respects the chef. I have full control
              over my time and my profit margins."
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HomeChefQuantifiableSuccess;
